import React, { memo,  useEffect, useState } from "react";
import { styled } from '@mui/styles';
import NewReportLayout from "../layouts/ReportLayout/NewReportLayout";
import { getDatasets } from "../config/services/datasets";
import Loader from "./Loader";
import '../styling/report-theme2.css';
import { useDispatch } from "react-redux";
import { reportActions } from "../redux/reducers/report/reportReducer";

const RootStyle = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
})
const MainStyleWrapper = styled('div')(({ theme }) => ({
    height: '100%',
    width: '100%'
}))

const ReportNew = () => {
    const [dataSetList,setDataSetList] = useState(null)
    const [pageLoader, setPageLoader] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(reportActions.reset())
        document.title = 'Extramarks | Reporting-Engine'
        setPageLoader(true)
        getDatasets({})
            .then(res => {
                setPageLoader(false)
                const datasets = res.result.map(obj => {
                    obj.measures = obj.measures.sort((a,b) => a.type.localeCompare(b.type) || a.displayName.localeCompare(b.displayName))
                    obj.dimensions = obj.dimensions.sort((a,b) => a.type.localeCompare(b.type) || a.displayName.localeCompare(b.displayName))
                    obj.measures = obj.measures.map(mes => {
                        mes.title = `${obj.dataSetName}.${mes.name}`
                        return mes
                    })
                    obj.dimensions = obj.dimensions.map(dim => {
                        dim.title = `${obj.dataSetName}.${dim.name}`
                        return dim
                    })
                    return {label:obj.displayName,...obj}
                })
                setDataSetList(datasets)
                //console.log(res)
            })
            .catch(err => {
                setPageLoader(false)
                setDataSetList([])
            })

            return () => {
                //unmount logic goes here
            }
    },[])

    /* useEffect(() => {
        (async function loadMeta() {
            const meta = await cubejsApi.meta();
            setMeta(meta);
          })();
    },[]) */
    return  <RootStyle className="re-theme2">
        <MainStyleWrapper>
            {pageLoader && <Loader />}
            {dataSetList && <NewReportLayout
                dataSetList={dataSetList}
            />}
        </MainStyleWrapper>
    </RootStyle>  
}

export default  memo(ReportNew)